module.exports = __webpack_public_path__ + "img/edit-no-border.0043a849.svg";